import { isAndroid, isIOS } from 'react-device-detect'

const { userAgent } = navigator

const appUserAgent = {
    iPad: 'Mozilla/5.0 (iPad; CPU OS 12_2 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/12.1 Mobile/15E148 Safari/604.1',
    iPhone: 'Mozilla/5.0 (iPhone; CPU iPhone OS 12_2 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/12.1 Mobile/15E148 Safari/604.1',
    Android: 'Mozilla/5.0 (Linux; Android 5.0.2; SM-G920T Build/LRX22G) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/43.0.2357.78 Mobile Safari/537.36'
}

export const isIPadApp = () => userAgent === appUserAgent.iPad
export const isIPhoneApp = () => userAgent === appUserAgent.iPhone
export const isAndroidApp = () => userAgent === appUserAgent.Android || userAgent.match(/VM_ANDROID_APP/i)

export const isIOSApp = () => isIPadApp() || isIPhoneApp()

export const isMobileApp = () => isIPadApp() || isIPhoneApp() || isAndroidApp()

export const checkMobileType = () => {
    if (isIOS) return 'ios'
    else if (isAndroid) return 'android'
    else return false
}